// extracted by mini-css-extract-plugin
export default {"container":"EO-z","topReviewHeading":"FO-z","criticalReview":"GO-z","favorableReview":"HO-z","vsSeparator":"IO-z"};